import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const ParallaxBg = ({ image, opacity = 0.16 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    const tween = gsap.fromTo(
      el,
      { yPercent: -12 },
      {
        yPercent: 12,
        ease: "none",
        scrollTrigger: {
          trigger: el.parentElement,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      }
    );
    return () => { tween.scrollTrigger?.kill(); tween.kill(); };
  }, []);
  return (
    <div className="parallax-bg" aria-hidden="true">
      <div ref={ref} className="parallax-bg-img" style={{ backgroundImage: `url(${image})`, opacity }} />
    </div>
  );
};
